module.exports = __webpack_public_path__ + "img/kongxiaolei.b4cf8d66.jpg";